import React, { memo, useCallback, useState } from 'react';
import { CbmModal as Modal, Text } from '@groupelacentrale/contact-storybook';
import { PhotoCharterTableRow } from './PhotoCharterTableRow';
import photo1 from 'assets/PhotoCharter/photo-charte01.png';
import photo2 from 'assets/PhotoCharter/photo-charte02.png';
import photo3 from 'assets/PhotoCharter/photo-charte03.png';
import photo4 from 'assets/PhotoCharter/photo-charte04.png';
import photo5 from 'assets/PhotoCharter/photo-charte05.png';
import photo6 from 'assets/PhotoCharter/photo-charte06.png';
import photo7 from 'assets/PhotoCharter/photo-charte07.png';
import photo8 from 'assets/PhotoCharter/photo-charte08.png';
import photo9 from 'assets/PhotoCharter/photo-charte09.png';
import photo10 from 'assets/PhotoCharter/photo-charte10.png';
import photo11 from 'assets/PhotoCharter/photo-charte11.png';
import photo12 from 'assets/PhotoCharter/photo-charte12.png';
import photo13 from 'assets/PhotoCharter/photo-charte13.png';
import './PhotoCharter.scss';

interface Props {
  maxFileSize: number;
}

const PhotoCharter: React.FC<Props> = memo(({ maxFileSize }) => {
  const [isOpen, setOpen] = useState<boolean>(false);

  const toggle = useCallback(() => {
    setOpen(open => !open);
  }, []);

  return (
    <>
      <span className="photo-charter-handle" onClick={toggle}>
        Consulter la charte photo
      </span>
      <Modal title="Charte photo La Centrale" onClose={toggle} isOpen={isOpen} showCloseButton size="medium">
        <div className="photo-charter-content">
          <Text>
            L&apos;ordre d&apos;affichage et la classification des photos (intérieur, extérieur, roues, ...) sont
            assurés automatiquement par nos systèmes sur la base d&apos;un processus d&apos;apprentissage par
            intelligence artificielle.
          </Text>

          <Text size="large" weight="bold">
            Eléments obligatoires
          </Text>

          <ul>
            <li>
              <Text>
                Les photos doivent représenter fidèlement le bien annoncé et ne pas induire en erreur le public
              </Text>
            </li>
            <li>
              <Text>
                L’annonceur doit disposer de l’ensemble des droits de propriété intellectuelle des photos qui illustrent
                son annonce
              </Text>
            </li>
            <li>
              <Text>
                La photo principale doit être une photo de l’extérieur du véhicule le représentant dans son intégralité
              </Text>
            </li>
          </ul>

          <Text size="large" weight="bold">
            Eléments acceptés
          </Text>

          <Text>Pour les autres photos que la photo principale :</Text>

          <ul>
            <li>
              <Text>
                Photo d’une partie du véhicule (intérieur ou extérieur), détails (volant, compteur,…), logo du véhicule
              </Text>
            </li>
            <li>
              <Text>Photo des factures, contrôle technique, carnet d’entretien, mode d’emploi, clefs,…</Text>
            </li>
          </ul>

          <Text size="large" weight="bold">
            Eléments refusés
          </Text>

          <ul>
            <li>
              <Text>Photo avec commentaire</Text>
            </li>
            <li>
              <Text>Photo de mauvaise qualité (mal cadrée, sombre, floue)</Text>
            </li>
            <li>
              <Text>Photo « catalogue » ou « constructeur »</Text>
            </li>
            <li>
              <Text>Photo prise de loin où le véhicule annoncé n’est pas identifiable</Text>
            </li>
            <li>
              <Text>Photos de plusieurs véhicules où le véhicule annoncé n’est pas identifiable</Text>
            </li>
            <li>
              <Text>Photos présentant des personnes</Text>
            </li>
            <li>
              <Text>Photos-montages (plusieurs photos en une)</Text>
            </li>
          </ul>
          <Text size="large" weight="bold">
            Exemples de photos acceptées :
          </Text>

          <table>
            <PhotoCharterTableRow valid photo={photo1} text="Pour une photo principale" />
            <PhotoCharterTableRow valid photo={photo2} text="Pour une photo principale" />
            <PhotoCharterTableRow valid photo={photo3} text="Pour une photo principale" />
            <PhotoCharterTableRow valid photo={photo4} text="Pour une photo principale" />
            <PhotoCharterTableRow valid photo={photo5} text="Pour une photo secondaire" />
            <PhotoCharterTableRow valid photo={photo6} text="Pour une photo secondaire" />
            <PhotoCharterTableRow valid photo={photo7} text="Pour une photo secondaire" />
            <PhotoCharterTableRow valid photo={photo8} text="Pour une photo secondaire" />
            <PhotoCharterTableRow valid photo={photo9} text="Pour une photo secondaire" />
          </table>

          <Text size="large" weight="bold">
            Exemples de photos pouvant être refusées :
          </Text>

          <table>
            <PhotoCharterTableRow photo={photo10} text="Image floue" />
            <PhotoCharterTableRow photo={photo11} text="Image avec des personnes" />
            <PhotoCharterTableRow photo={photo12} text="Photo-montage" />
            <PhotoCharterTableRow
              photo={photo13}
              text={
                <>
                  Photo partielle du véhicule
                  <br />
                  (pour la photo principale)
                </>
              }
            />
          </table>

          <Text size="large" weight="bold">
            Format des photos :
          </Text>

          <ul>
            <li>
              <Text>Les photos pourront être au format jpeg, jpg ou png</Text>
            </li>
            <li>
              <Text>Poids maximum par photo : {maxFileSize} Mo</Text>
            </li>
          </ul>
        </div>
      </Modal>
    </>
  );
});

PhotoCharter.displayName = 'PhotoCharter';

export { PhotoCharter };
